'use strict';

var angularModule = angular.module('t2g.common.services.appointmentModel', [
  'ui.router',
  require('t2g.common.services.cacheService').name,
  require('t2g.common.services.RESTService').name,
  require('t2g.common.services.sessionStorage').name,
]);

module.exports = angularModule;

angularModule.factory('AppointmentModel', function(
  $rootScope,
  $state,
  $timeout,
  Appointment,
  AppointmentCache,
  io,
) {
  var changeHandler = {
    add: [],
    remove: [],
    edit: [],
  };

  var fireHandler = function(eventName, appointment) {
    var handlerLen = changeHandler[eventName].length;

    for (var i = 0; i < handlerLen; i++) {
      changeHandler[eventName][i].call(appointment);
    }
  };

  return {
    on: function(eventName, callback) {
      changeHandler[eventName].push(callback);
    },
    get: function(date, range, forceReload, callback) {
      var dateParts = date.split('-');
      var dateStart = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      var response = [];

      // check if is necessary to from api
      for (var i = 0; i < range; i++) {
        var dateTemp = new Date(dateStart.getTime() + i * 86400000);
        var dateString =
          dateTemp.getDate() + '-' + (dateTemp.getMonth() + 1) + '-' + dateTemp.getFullYear();
        var cachedAppointments = AppointmentCache.get(dateString);

        if (cachedAppointments) {
          response.push(cachedAppointments);
        } else {
          response = [];
          break;
        }
      }

      if (response.length < range) {
        Appointment.query({ start: date, range: range }, function(appointmentDays) {
          if (appointmentDays instanceof Array) {
            for (var i = 0, daysLen = appointmentDays.length; i < daysLen; i++) {
              appointmentDays[i].date = new Date(appointmentDays[i].date);

              // parse start and end dates
              for (var j = 0, objLen = appointmentDays[i].objects.length; j < objLen; j++) {
                for (
                  var k = 0, appLen = appointmentDays[i].objects[j].appointments.length;
                  k < appLen;
                  k++
                ) {
                  appointmentDays[i].objects[j].appointments[k].start = new Date(
                    appointmentDays[i].objects[j].appointments[k].start,
                  );
                  appointmentDays[i].objects[j].appointments[k].end = new Date(
                    appointmentDays[i].objects[j].appointments[k].end,
                  );
                }
              }

              AppointmentCache.put(
                appointmentDays[i].date.getDate() +
                  '-' +
                  (appointmentDays[i].date.getMonth() + 1) +
                  '-' +
                  appointmentDays[i].date.getFullYear(),
                appointmentDays[i],
              );
              response.push(appointmentDays[i]);
            }

            callback(null, response);
          } else {
            callback('Error: cant load appointments for date: ' + date);
          }
        });
      } else {
        callback(null, response);
      }
    },
    save: function(appointment, callback) {
      var that = this;

      if (appointment.recurring && appointment.recurring.times) {
        appointment.recurring.times = parseInt(appointment.recurring.times, 10);
      }

      Appointment.save(appointment).$promise.then(
        function(appointments) {
          // parse start and end dates
          for (var i = 0, appLen = appointments.length; i < appLen; i++) {
            appointments[i].start = new Date(appointments[i].start);
            appointments[i].end = new Date(appointments[i].end);
          }

          io.emit('Appointment:save', appointments);

          that.insertToCache(appointments);

          $rootScope.$broadcast('Appointment:save');

          fireHandler('add', appointment);

          fireHandler('add', appointment);

          callback(null, appointments);
        },
        function() {
          callback('Cant insert new appointment');
        },
      );
    },
    update: function(appointment, oldDate, callback) {
      var that = this;

      if (appointment.recurring && appointment.recurring.times) {
        appointment.recurring.times = parseInt(appointment.recurring.times, 10);
      }

      Appointment.update(appointment).$promise.then(
        function(reponse) {
          var appointments = reponse.appointments;
          appointment = appointments[0];

          // clear old date if date differs (e.g. if appointment was dragged)
          appointment.start = new Date(appointment.start);

          // clear old date
          var oldCachedDay = AppointmentCache.get(oldDate);

          if (oldCachedDay) {
            _.forEach(oldCachedDay.objects, function(object) {
              _.remove(object.appointments, function(oldAppointment) {
                return oldAppointment._id === appointment._id;
              });
            });
            AppointmentCache.remove(oldDate);
            AppointmentCache.put(oldDate, oldCachedDay);
          }

          io.emit('Appointment:edit', appointments);
          that.insertToCache(appointments);
          $rootScope.$broadcast('Appointment:edit');
          callback();
          fireHandler('edit', appointment);
        },
        function() {
          callback('Cant update appointment');
        },
      );
    },
    delete: function(appointment, callback) {
      appointment.start = new Date(appointment.start);
      var date =
        appointment.start.getDate() +
        '-' +
        (appointment.start.getMonth() + 1) +
        '-' +
        appointment.start.getFullYear();

      if (appointment instanceof Object) {
        appointment = new Appointment(appointment);
      }

      appointment.$delete(
        { appointmentId: appointment._id },
        function(response) {
          // refresh cache to avoid reloading from API
          var tempCache = AppointmentCache.get(date);

          if (tempCache) {
            for (var i = 0; i < tempCache.objects.length; i++) {
              for (var j = 0; j < tempCache.objects[i].appointments.length; j++) {
                if (tempCache.objects[i].appointments[j]._id == response._id) {
                  tempCache.objects[i].appointments.splice(j, 1);
                  AppointmentCache.remove(date);
                  AppointmentCache.put(date, tempCache);

                  break;
                }
              }
            }
          }
          fireHandler('remove', appointment);

          $rootScope.$broadcast('Appointment:delete', response._id);

          callback(null, response);
        },
        function() {
          callback('Cant delete appointment');
        },
      );
    },
    insertToCache: function(appointments, broadcast) {
      angular.forEach(appointments, function(appointment) {
        appointment.start = new Date(appointment.start);
        var date = moment(appointment.start).format('D-M-YYYY');

        // refresh cache to avoid reloading from API
        var tempCache = AppointmentCache.get(date);

        if (tempCache) {
          for (var i = 0, objLen = tempCache.objects.length; i < objLen; i++) {
            var appointmentInCache = false;

            if (tempCache.objects[i]._id === appointment.object._id) {
              // check if appointment is already in cache
              for (var j = 0, appLen = tempCache.objects[i].appointments.length; j < appLen; j++) {
                if (tempCache.objects[i].appointments[j]._id === appointment._id) {
                  appointmentInCache = true;
                  tempCache.objects[i].appointments[j] = appointment;
                  break;
                }
              }

              if (!appointmentInCache) {
                tempCache.objects[i].appointments.push(appointment);
              }

              break;
            }
          }

          AppointmentCache.remove(date);
          AppointmentCache.put(date, tempCache);
          if (broadcast) {
            fireHandler('edit', appointment);
          }
        }
      });
    },
    clearCache: function() {
      AppointmentCache.removeAll();
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/services/AppointmentModel.js